import React,{useState} from 'react'
import './App.css';
import {Configuration,OpenAIApi} from 'openai'


function App() {
  const [prompt,setPropmt]=useState("")  
  const [result,setresult]=useState('')
  const [msg,setmsg]=useState();
  const [nomsg,setnomsg]=useState(false)
  const configuration = new Configuration({
    apiKey: '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',
  });

  const openai = new OpenAIApi(configuration);

   const generateImage =async ()=>{
    if(msg===""){
       setnomsg(true);
       return;
    }
    else{
    setmsg(true);
    const res=await openai.createImage({
     
      prompt: prompt,
     n:1,
     size:"1024x1024"
    });
    
    
    setresult(res.data.data[0].url);
    setmsg(false)
   }
   setPropmt("")
  }

  //  const Varient = async()=>{
  //   const response = await openai.createImageVariation(
  //       result.createReadStream('corgi_and_cat_paw.png'),
  //     1,
  //     "1024x1024" 
  //   );

  //   console.log(response.data.data[0].url)
  //  }
   
  return (
    <div className="App">
   

     <input onChange={(e)=>setPropmt(e.target.value)}  value={prompt}  placeholder="type something to generate....."/>
      <button 
          onClick={generateImage}
          >Generate a Image</button>
         {nomsg ? <>
          <h3>Please type something to  generate...</h3>
         </>:<></>}

          {msg ? <><div class="lds-ripple"><div></div><div></div></div> <span>Wait it is generating....</span></>:<></>}
         {result.length >0 ?<div className='result' > <img src={result} alt='result'/> <br/>
          </div> :<></>}
          
    </div>
  );
}

export default App;
